<template>
    <v-layout column class="spouse-partner-login-assistance">
        <v-flex xs12 class="spouse-partner-login-assistance__subtitle">
            {{loginConstants.ENTER_REQUIRED_INFO}}
        </v-flex>
        <v-flex xs12 class="spouse-partner-login-assistance__form">
            <v-form v-model="valid" ref="spousePartnerLoginAssistance">
                <v-layout column align-content-start justify-start>
                    <v-flex mr-2 xs12 pb-2>
                        <div class="spouse-partner-login-assistance__form--label">{{loginConstants.FIRST_NAME}}</div>
                        <v-text-field
                            id="first_name_input"
                            data-qe-id="first_name_input"
                            name="firstName"
                            autofocus
                            v-model="spouseLoginAssistance.firstName"
                            :rules="firstNameRules"
                            validate-on-blur
                            :disabled="isSubmitting"
                            :onkeyup="resetError()"
                            required
                            v-on:keydown.enter.prevent>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 pb-2>
                        <div class="spouse-partner-login-assistance__form--label">{{loginConstants.LAST_NAME}}</div>
                        <v-text-field
                            id="last_name_input"
                            data-qe-id="last_name_input"
                            name="lastName"
                            v-model="spouseLoginAssistance.lastName"
                            :rules="lastNameRules"
                            validate-on-blur
                            :disabled="isSubmitting"
                            :onkeyup="resetError()"
                            required
                            v-on:keydown.enter.prevent>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <div v-if="!isExternalSpeaker" class="spouse-partner-login-assistance__form--label">{{loginConstants.PRIMARY_MEMBER_PHONE_NUMBER}}</div>
                        <div v-else class="spouse-partner-login-assistance__form--label">{{loginConstants.PHONE_NUMBER}}</div>
                        <v-layout
                            row
                            align-content-start
                            justify-start
                            pt-1>
                            <v-flex mr-2 xs4>
                                <v-text-field
                                    id="country_code_input"
                                    data-qe-id="country_code_input"
                                    name="countryCode"
                                    :placeholder="loginConstants.COUNTRY_CODE"
                                    v-model="spouseLoginAssistance.countryCode"
                                    :rules="countryCodeRules"
                                    :disabled="isSubmitting"
                                    :maxlength="loginConstants.MAXIMUM_LENGTH_FOR_COUNTRY_CODE"
                                    :onkeyup="resetError()"
                                    required
                                    v-on:keydown.enter.prevent>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    id="phone_number_input"
                                    data-qe-id="phone_number_input"
                                    name="phoneNumber"
                                    :placeholder="loginConstants.PHONE_NUMBER"
                                    v-model="spouseLoginAssistance.phoneNumber"
                                    :maxlength="loginConstants.MAXIMUM_LENGTH_FOR_PHONE_NUMBER"
                                    :rules="phoneNumberRules"
                                    :disabled="isSubmitting"
                                    :onkeyup="resetError()"
                                    required
                                    v-on:keydown.enter.prevent>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-flex>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row wrap pt-3>
                <v-btn
                    flat
                    large
                    id="return_to_home_btn"
                    data-qe-id="return_to_home_btn"
                    block
                    class="ypo_blue--text"
                    @click="returnToMainPage()"
                    :disabled="isSubmitting">
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn
                    id="submit_password_recovery_btn"
                    data-qe-id="submit_password_recovery_btn"
                    color="ypo_blue"
                    class="white--text"
                    @click="submit"
                    :disabled="!canSave"
                    large
                    block>
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";

    export default {
        name: 'SpousePartnerLoginAssistance',
        components: { LoginError },
        created() {
            this.spouseLoginAssistance = {
                firstName: '',
                lastName: '',
                countryCode: '',
                phoneNumber: '',
            };
        },
        data: () => ({
            loginConstants,
            valid: false,
            spouseLoginAssistance: null,
            componentNames: loginConstants.componentNames,
            numberOfAttempts: 0,
            countryCodeRules: [
                v => !!v || loginConstants.errors.COUNTRY_CODE_REQUIRED,
                v => !!v.match(/^\d+$/) || loginConstants.errors.COUNTRY_CODE_TYPE_ERROR,
            ],
            phoneNumberRules: [
                v => !!v || loginConstants.errors.PHONE_NUMBER_REQUIRED,
                v => !!v.match(/^[a-zA-Z0-9\-.()\s]+$/) || loginConstants.errors.PHONE_NUMBER_TYPE_ERROR,
            ],
            firstNameRules: [
                v => !!v || loginConstants.errors.FIRST_NAME_IS_REQUIRED,
            ],
            lastNameRules: [
                v => !!v || loginConstants.errors.LAST_NAME_IS_REQUIRED,
            ],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
            recoveryType: String,
        },
        methods: {
            ...mapActions({
                submitLoginAssistanceForSpousePartner: `auth/${storeAction.submitLoginAssistanceForSpousePartner}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
            }),
            submit() {
                this.toggleProgressIndicator();
                if (this.$refs.spousePartnerLoginAssistance.validate()) {
                    this.numberOfAttempts += 1;
                    const { recoveryType, spouseLoginAssistance } = this;
                    this.submitLoginAssistanceForSpousePartner({ ...spouseLoginAssistance, recoveryType, urlRecoveryType: (this.isExternalSpeaker ? "speakerRecovery" : 'spouseRecovery') })
                        .then((resp) => {
                            this.toggleProgressIndicator();
                            if (resp.data && resp.data.duplicateUserFound) {
                                this.changeCardState(this.componentNames.contactUsForFurtherAssistance.component);
                            } else if (recoveryType === loginConstants.spousePartnerLoginAssistance.PASSWORD) {
                                this.changeCardState(this.componentNames.selectTypePasswordDelivery.component);
                            } else {
                                this.changeCardState(this.componentNames.usernameRecoveryOptions.component);
                            }
                        })
                        .catch(() => {
                            this.toggleProgressIndicator();
                            if (this.numberOfAttempts === loginConstants.MAXIMUM_ATTEMPTS_FOR_SPOUSE_LOGIN_ASSISTANCE) {
                                this.changeCardState(this.componentNames.contactUsForFurtherAssistance.component);
                            }
                        });
                }
            },
            resetError() {
                Object.keys(this.spouseLoginAssistance).forEach((key) => {
                    if (this.spouseLoginAssistance.hasOwnProperty(key) && !this.spouseLoginAssistance[key]) {
                        this.clearErrorOnStateChange(null);
                    }
                });
            },
            returnToMainPage() {
                this.returnToLogin();
            },
        },
        computed: {
            ...mapGetters({
                memberFurtherSecurityDetails: `auth/${storeGetters.getMemberAdditionalSecurityObject}`,
                isExternalSpeaker: `auth/${storeGetters.isExternalSpeaker}`,
            }),
            canSave() {
                let ableToSave = true;
                Object.keys(this.spouseLoginAssistance).forEach((key) => {
                    if (this.spouseLoginAssistance.hasOwnProperty(key) && !this.spouseLoginAssistance[key]) {
                        ableToSave = false;
                    }
                });

                return ableToSave && this.valid && !this.isSubmitting;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .spouse-partner-login-assistance {

        &__subtitle {
            padding: 5px 0 20px;
            font-size: 15px;
        }

        &__form {
            &--label {
                font-size: 14px;
                font-weight: 600;
                color: $ypo-blue;
            }

            .v-input {
                padding-top: 0 !important;
            }
        }
    }
</style>
